import { computed } from 'vue'
import { CSS_CLASSES } from '../constants/split-button-constants.js'

/**
 * Styles composable for MsSplitButton
 * Handles CSS classes and style computations
 */
export function useSplitButtonStyles(props, splitButtonState) {
  // Main container classes
  const splitButtonClasses = computed(() => [
    CSS_CLASSES.SPLIT_BUTTON,
    CSS_CLASSES.FLEX_CENTER,
    splitButtonState.shouldShowParentBorder.value ? CSS_CLASSES.BORDER_SPLIT_BTN : ''
  ])

  // Primary button classes
  const primaryButtonClasses = computed(() => [
    CSS_CLASSES.PRIMARY_BUTTON,
    props.type,
    props.classCustom,
    splitButtonState.shouldShowBorder.value ? '' : CSS_CLASSES.BTN_BORDER_NONE
  ])

  // Left icon classes
  const leftIconClasses = computed(() => [
    CSS_CLASSES.ICON24,
    CSS_CLASSES.ICON_LEFT,
    props.leftIcon
  ])

  // Text classes
  const textClasses = computed(() => [
    CSS_CLASSES.TEXT,
    splitButtonState.hasLeftIcon.value ? CSS_CLASSES.TEXT_PL_0 : ''
  ])

  // Menu wrapper classes
  const menuWrapperClasses = computed(() => [
    CSS_CLASSES.WIDGET_MORE_CONTAINER,
    props.type
  ])

  // Menu button classes (widget-more)
  const menuButtonClasses = computed(() => [
    CSS_CLASSES.WIDGET_MORE,
    props.type,
    props.classCustom,
    splitButtonState.shouldShowBorder.value ? '' : CSS_CLASSES.BTN_BORDER_NONE
  ])

  // Show/hide computations
  const showLeftIcon = computed(() => {
    return splitButtonState.hasLeftIcon.value
  })

  const showText = computed(() => {
    return splitButtonState.hasText.value
  })

  return {
    // CSS classes
    splitButtonClasses,
    primaryButtonClasses,
    leftIconClasses,
    textClasses,
    menuWrapperClasses,
    menuButtonClasses,
    
    // Show/hide
    showLeftIcon,
    showText
  }
}
